'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../core/Style');

var _TwoWayTransition = require('./TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AccordionTransitionWrapper = (0, _styledComponents2.default)(function (props) {
  var hidden = props.hidden,
      __measuredHeight = props.measuredHeight,
      transitioning = props.transitioning,
      rest = _objectWithoutProperties(props, ['hidden', 'measuredHeight', 'transitioning']);

  return _react2.default.createElement(_TwoWayTransition2.default.PlainWrapper, _extends({
    'data-open-complete': !hidden && !transitioning
  }, rest));
}).withConfig({
  displayName: 'AccordionTransition__AccordionTransitionWrapper'
})(['transition:', ';height:', ';opacity:', ';pointer-events:', ';transform:', ';overflow:hidden;'], function (_ref) {
  var duration = _ref.duration,
      measuredHeight = _ref.measuredHeight,
      transitionActive = _ref.transitionActive;
  return measuredHeight != null && transitionActive ? 'height ' + duration + 'ms cubic-bezier(0.25, 0.1, 0.25, 1),\n    opacity ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1),\n    transform ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1)' : 'none';
}, function (_ref2) {
  var hidden = _ref2.hidden,
      measuredHeight = _ref2.measuredHeight,
      transitioning = _ref2.transitioning;
  return transitioning && (hidden ? 0 : measuredHeight + 'px');
}, function (_ref3) {
  var hidden = _ref3.hidden,
      transitioning = _ref3.transitioning;
  return transitioning && (hidden ? 0 : 1);
}, function (_ref4) {
  var transitioning = _ref4.transitioning;
  return transitioning && 'none';
}, function (_ref5) {
  var hidden = _ref5.hidden,
      transitioning = _ref5.transitioning;
  return transitioning && (hidden ? 'translateY(' + (0, _Style.remCalc)(-10) + ')' : 'translateY(0)');
});

var AccordionTransition = function (_PureComponent) {
  _inherits(AccordionTransition, _PureComponent);

  function AccordionTransition(props) {
    _classCallCheck(this, AccordionTransition);

    var _this = _possibleConstructorReturn(this, (AccordionTransition.__proto__ || Object.getPrototypeOf(AccordionTransition)).call(this, props));

    _this.state = {
      measuredHeight: 0, // 0 = not needed, null = needed
      transitioning: false
    };
    _this.handleTransitionStart = _this.handleTransitionStart.bind(_this);
    _this.handleTransitionComplete = _this.handleTransitionComplete.bind(_this);
    return _this;
  }

  _createClass(AccordionTransition, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.open !== nextProps.open && !this.state.transitioning) {
        this.setState({ measuredHeight: null });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.measuredHeight == null) {
        this.measureHeight();
      }
    }
  }, {
    key: 'measureHeight',
    value: function measureHeight() {
      var el = (0, _reactDom.findDOMNode)(this);
      if (!el) return;
      this.setState({ measuredHeight: el.scrollHeight });
    }
  }, {
    key: 'handleTransitionStart',
    value: function handleTransitionStart() {
      this.setState({ transitioning: true });
    }
  }, {
    key: 'handleTransitionComplete',
    value: function handleTransitionComplete() {
      this.setState({ transitioning: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Content = _props.Content,
          duration = _props.duration,
          onOpenStart = _props.onOpenStart,
          onCloseStart = _props.onCloseStart,
          onOpenComplete = _props.onOpenComplete,
          onCloseComplete = _props.onCloseComplete,
          open = _props.open,
          rest = _objectWithoutProperties(_props, ['children', 'Content', 'duration', 'onOpenStart', 'onCloseStart', 'onOpenComplete', 'onCloseComplete', 'open']);

      var renderedContent = null;
      if (open) {
        renderedContent = Content ? _react2.default.createElement(Content, null) : children;
      }

      return _react2.default.createElement(
        _TwoWayTransition2.default,
        _extends({}, rest, {
          duration: duration,
          measuredHeight: this.state.measuredHeight,
          onOpenStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onOpenStart),
          onCloseStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onCloseStart),
          onOpenComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onOpenComplete),
          onCloseComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onCloseComplete)
        }),
        renderedContent
      );
    }
  }]);

  return AccordionTransition;
}(_react.PureComponent);

AccordionTransition.propTypes = {
  children: _react.PropTypes.node,
  Content: _component2.default,
  duration: _react.PropTypes.number.isRequired,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  open: _react.PropTypes.bool.isRequired,
  Wrapper: _component2.default.isRequired
};

AccordionTransition.defaultProps = {
  duration: 200,
  Wrapper: AccordionTransitionWrapper
};

AccordionTransition.displayName = 'AccordionTransition';

exports.default = AccordionTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/transitions/AccordionTransition.js
// module id = 216
// module chunks = 171